import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { OrganizationsActions } from 'state/modules/organizations';
import VersionFileInput from 'components/Documents/VersionFileInput';
import { uiActions } from 'state/modules/UI';
import { useStyles } from './UploadOrgSettingLogo.styled';

const UploadOrgSettingLogoModal = ({ id, open, handleClick }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [logo, setLogo] = useState();

  const { loading, fetchedUploadLogoSuccess } = useSelector((state) => state.organizations);

  useEffect(() => {
    if (id) {
      dispatch(OrganizationsActions.fetchOrganizationById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (fetchedUploadLogoSuccess) {
      handleClick();
      dispatch(OrganizationsActions.resetUploadOrganizationLogo());
      dispatch(OrganizationsActions.fetchOrganizationById(id));
    }
  }, [fetchedUploadLogoSuccess, id, handleClick, dispatch]);

  const uploadFile = () => {
    dispatch(OrganizationsActions.fetchUploadOrganizationLogo(id, logo));
  };

  const changeLogo = (key, value) => {
    setLogo(value);
  };

  const setError = () => {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: i18n.t('organization.image_error'),
      })
    );
  };

  return (
    <BaseModal
      size="md"
      open={open}
      hasEnterButton
      hasCancelButton
      loading={loading}
      onEnter={uploadFile}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      enterButtonLabel={i18n.t('common.update')}
      title={i18n.t('organization.update_organization_logo')}
    >
      <span style={{ fontSize: 12 }}>
        <p>{i18n.t('organization.image_info_title')}</p>
        <br />
        <p>{i18n.t('organization.image_specs_title')}</p>
        <ul className={classes.specs}>
          <li>{i18n.t('organization.image_type')}</li>
          <li>{i18n.t('organization.image_size')}</li>
        </ul>
      </span>
      <VersionFileInput
        name="file"
        hideDelete={true}
        size={{
          width: 155,
          height: 55,
        }}
        onChange={changeLogo}
        onError={setError}
        isUploading={loading}
        fetchedUploadFile={true}
      />
    </BaseModal>
  );
};

UploadOrgSettingLogoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

UploadOrgSettingLogoModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default UploadOrgSettingLogoModal;
